import APIService from "@/services/apiservice";

export default class AuthorityEntityLookupService {
    public static Lookup = (mid : string) => 
    {
        return  APIService.GET(`/AuthorityLookup/entities/${mid}`)
    }
}

